<template>
  <div class="os-panel">

    <OsPanelCardItemFilter
        :search="search"
        :period="period"
        :initialPeriod="initialPeriod"
        :showDelivery="showDelivery"
        :showDevolution="showDevolution"
        :periodFilterOptions="periodFilterOptions"
        @update:search="search = $event"
        @update:period="period = $event"
        @update:showDelivery="showDelivery = $event; changedFilter()"
        @update:showDevolution="showDevolution = $event; changedFilter()"
        @filter-change="getAll"
    />

    <OsPanelCardItemTopbar :sizeFullData="sizeFullData"/>

    <Loading type="line" :center="false" v-show="loading"/>

    <div class="cards-grid">
      <div class="card-wrap" v-for="item in data" :key="item.keyButton">
        <OsPanelCardItem
            :item="item"
            @view="clickedEvent"
            @edit="edit"
            @share="printRent"
        />
      </div>
    </div>

    <Loading type="line" :center="false" v-show="loadingLoadMore"/>

    <div class="load-more-wrap" v-if="sizeData < sizeFullData">
      <button class="load-more-btn" :class="{ 'load-more-btn--loading': loadingLoadMore }" @click="loadMore">
        <span class="load-more-btn__icon">
          <i class="fa-solid fa-arrows-rotate" :class="{ 'fa-spin': loadingLoadMore }"></i>
        </span>
        <span class="load-more-btn__text">Carregar mais</span>
        <span class="load-more-btn__badge">
          + {{ sizeFullData - sizeData }} item{{ (sizeFullData - sizeData) !== 1 ? 's' : '' }}
        </span>
      </button>
    </div>

    <Modal :title="titleModal" :width="widthModal" :height="750" v-if="showModal('infoOsPanel')"
           :onHideModal="closeModal">
      <OperationRent module="Operational" :rentId="rentId" :periodRentId="periodRentId" v-if="operational"/>
    </Modal>
    <PrintPreview v-if="print" module="Operational" :rentId="rentId" :periodRentId="periodRentId"
                  :onHideModal="closeModal"/>
  </div>
</template>
<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import OperationRent from "../../../components/modules/operational/OperationRent.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import PrintPreview from '../adm/document/PrintPreview.vue'
import OsPanelCardItemFilter from "./os-panel/OsPanelCardItemFilter.vue";
import OsPanelCardItemTopbar from "./os-panel/OsPanelCardItemTopbar.vue";
import OsPanelCardItem from "./os-panel/OsPanelCardItem.vue";

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "OsPanel",
  components: {
    Button,
    OsPanelCardItemFilter,
    OsPanelCardItemTopbar,
    OsPanelCardItem,
    OperationRent,
    Modal,
    Loading,
    PrintPreview,
  },
  data() {
    return {
      filter: this.$route.params.filter,
      urlGet: "/api/v1/operational/get-all-os-panel",
      data: [],
      fullData: [],
      itemsPerPage: 10,
      currentPage: 1,
      loading: true,
      showDelivery: true,
      showDevolution: true,
      showDone: false,
      titleModal: "",
      widthModal: 900,
      showPreview: false,
      documentId: "",
      rentId: "",
      periodRentId: "",
      selectedPeriod: [],
      initialPeriod: "today",
      period: "today",
      showAll: false,
      search: "",
      print: false,
      operational: false,
      loadingLoadMore: false,
      periodFilterOptions: [
        {
          title: "Hoje",
          classIcon: "fa-solid fa-calendar-day",
          value: "today",
        },
        {
          title: "Em atraso",
          classIcon: "fa-sharp fa-regular fa-sensor-triangle-exclamation",
          value: "delayed",
        },
        {
          title: "Semana",
          classIcon: "fa-solid fa-calendar-week",
          value: "week",
        },
        {title: "Mês", classIcon: "fa-solid fa-calendar-days", value: "month"},
        {title: "Ano", classIcon: "fa-solid fa-calendar", value: "year"},
      ],
    };
  },
  created() {
    if (this.filter) {
      this.period = this.filter;
      this.initialPeriod = this.filter;
    }

    const stored = this.filterStorage || {};
    this.showAll = !!stored.showAll;
    this.selectedPeriod = Array.isArray(stored.selectedPeriod) ? stored.selectedPeriod : [];
    this.initialPeriod = stored.period || this.initialPeriod;
    this.period = stored.period || this.period;
  },
  mounted() {
    this.getAll();
    window.addEventListener("scroll", this.verifyScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.verifyScroll);
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("generateMoviment", ["filterStorage"]),
    sizeFullData() {
      return this.fullData.length;
    },
    sizeData() {
      return this.data.length;
    },
    disabled() {
      if (Array.isArray(this.selectedPeriod) && this.selectedPeriod.length > 0) return true;
      return false;
    },
    isShowAll() {
      if (this.showAll) return true;
      return false;
    },
    isFilterActive() {
      if (this.period != "today") return true;
      if (Array.isArray(this.selectedPeriod) && this.selectedPeriod.length > 0) return true;
      if (this.showAll) return true;

      return false;
    }
  },
  methods: {
    ...mapMutations("generic", ["openModal", "addEvent", "removeLoading"]),
    ...mapMutations("generateMoviment", ["addFilterStorage"]),
    ...mapActions("generic", ["getApi"]),
    getAll() {
      this.loading = true;
      this.fullData = [];
      this.data = [];
      let params = {
        url: this.urlGet,
        obj: {
          showDelivery: this.showDelivery,
          showDevolution: this.showDevolution,
          search: this.search,
          done: this.showDone,
          period: this.period,
          showAll: this.showAll,
          start: this.selectedPeriod[0],
          end: this.selectedPeriod[1],
        },
      };

      this.addFilterStorage({showAll: this.showAll, selectedPeriod: this.selectedPeriod, period: this.period});

      this.getApi(params).then((response) => {
        this.fullData = response.content;
        this.data = this.fullData.slice(0, this.itemsPerPage);
        let self = this;
        setTimeout(function () {
          self.loading = false;
          self.removeLoading(["panel", "btnUpdate"]);
        }, 500);
      });
    },
    loadMore() {
      this.loadingLoadMore = true;
      setTimeout(() => {
        this.currentPage++;
        this.data = this.fullData.slice(0, this.itemsPerPage * this.currentPage);
        this.loadingLoadMore = false;
      }, 400);
    },
    verifyScroll() {
      const scrollFinal = window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;

      /*  if (scrollFinal && !this.loadingLoadMore) {
          this.loadingLoadMore = true;
          this.loadMore();
        }*/
    },
    changedFilter() {
      this.getAll();
    },
    endTime() {
      if (!this.loading) {
        this.getAll();
      }
    },
    nextStep() {
      this.showPreview = true;
      this.widthModal = 1200;
    },
    back() {
      this.showPreview = false;
      this.widthModal = 900;
      this.removeLoading(["back"]);
    },
    clickedEvent(item) {
      this.titleModal = `Locação Nº ${item.numberRent}`;
      this.operational = true;
      this.rentId = item.rentId;
      this.periodRentId = item.periodRentId;
      this.openModal("infoOsPanel");
      this.addEvent({
        name: "clickedEventCalendar",
        data: {rentId: this.rentId, periodRentId: this.periodRentId},
      });
      this.removeLoading([item.keyButton + 'eye']);
    },
    printRent(item) {
      this.print = true;
      this.rentId = item.rentId;
      this.periodRentId = item.periodRentId;
      this.removeLoading([item.keyButton + 'share']);
    },
    closeModal() {
      this.print = false;
      this.operational = false;
    },
    removeFilter() {
      this.selectedPeriod = [];
      this.initialPeriod = "today";
      this.period = "today";
      this.showAll = false;
      this.search = "";
    },
    edit(item) {
      let self = this;
      setTimeout(function () {
        self.$router.push({
          name: "rentOperationalUpdate",
          params: {id: item.rentId, periodRentId: item.periodRentId}
        });
        self.removeLoading([item.keyButton + 'edit']);
      }, 200);
    }
  },
  watch: {
    period: {
      handler() {
        this.getAll();
      },
      deep: true,
    },
    showAll: {
      handler() {
        this.getAll();
      },
      deep: true,
    },
    selectedPeriod: {
      handler() {
        this.getAll();
      },
      deep: true,
    },
    search: {
      handler() {
        if (this.search.length == 0)
          this.getAll();
      },
      deep: true,
    },
    event: {
      handler(event) {
        if (event.name == "emailSent") {
          this.print = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 4px;
}

@media (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 860px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 540px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}

.card-wrap {
  min-width: 0;
}

.load-more-wrap {
  display: flex;
  justify-content: center;
  padding-top: 28px;
  padding-bottom: 16px;
}

.load-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 11px 28px;
  background: #fff;
  border: 1.5px dashed #c9d3e0;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 600;
  color: #4b5563;
  transition: background 0.18s, border-color 0.18s, color 0.18s, box-shadow 0.18s;
  outline: none;
}

.load-more-btn:hover {
  background: #f0f7ff;
  border-color: #4bb4e2;
  color: #1e7ea1;
  box-shadow: 0 2px 12px rgba(75, 180, 226, 0.15);
}

.load-more-btn:active {
  transform: scale(0.97);
}

.load-more-btn--loading {
  pointer-events: none;
  opacity: 0.7;
}

.load-more-btn__icon {
  font-size: 14px;
  color: #4bb4e2;
}

.load-more-btn__text {
  letter-spacing: 0.3px;
}

.load-more-btn__badge {
  background: #e8f5fb;
  color: #1e7ea1;
  font-size: 11.5px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 999px;
  letter-spacing: 0.2px;
}
</style>
